
import request from '@/request/request.js'

// 项目列表
export const getNewsList = (params) => {
    return request.post("/getNews",params);
}
// 获取Banner列表
// 返回数据-页面控制情况
export const getBannerList = (params) => {
    // console.log('00000');
    return request.post("/getBanner",params);
}
// /getTitle获取title
// // 返回数据-页面控制情况
export const getTitleList = () => {
    // console.log('00000');
    return request.post('/getTitle');
}
// 新增留言接口
export const getInsertMessage = (params) => {
    // console.log('00000');
    return request.post("/insertMessage",params);
}
// 记录流量次数的接口readAdd
export const getReadAdd = (params) => {
    // console.log('00000');
    return request.post("/readAdd",params);
}